import React, { useState, useEffect, useRef } from "react";
import validator from "validator";
import "./LoginPage.css";

import CartInputField from "../Components/Cart/CartInputField";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import OkPopup from "../Components/OkPopup";

function Register(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [netError, setNetError] = useState(null);
  const [rispostaWS, setRispostaWS] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const closeAddedDialog = () => {
    setShowDialog(false);
  };

  const [formMail, setFormMail] = useState("");
  const [formNome, setFormNome] = useState("");
  const [formCognome, setFormCognome] = useState("");
  const [formTelefono, setFormTelefono] = useState("");
  const [formCap, setFormCap] = useState("");
  const [formPassword, setFormPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [privacyOption, setPrivacyOption] = useState(false); // aggiunta da Manuele

  const [HasMessage, setHasMessage] = useState(null);
  const [errorList, setErrorList] = useState([]);

  function checkTextValue(txt, fieldName, special = "") {
    if (txt.trim().length === 0) {
      return "Si prega di non lasciare il campo vuoto.";
    }
    switch (special) {
      case "phone":
        if (!txt.match(/^[0-9\s(+)-]*$/)) {
          return "Inserire un numero di telefono valido.";
        }
        if (txt.length < 8) {
          return "Numero troppo corto.";
        }
        break;
      case "email":
        if (!validator.isEmail(txt)) {
          return "Inserire un indirizzo di email valido.";
        }
        break;
      case "cap":
        if (!validator.isPostalCode(txt, "IT")) {
          return "Inserire un CAP valido.";
        }
        break;
    }
    return "";
  }

  function messageDialog(text) {
    return (
      <Dialog open={true}>
        <DialogContent>
          <p>{text}</p>
          <div
            className="chiudi_popup_button"
            onClick={() => closeMessageHandler()}
          >
            Chiudi
          </div>
        </DialogContent>
      </Dialog>
    );
  }

  function closeMessageHandler() {
    setHasMessage(null);
  }

  function validateForm() {
    // step 1: collect all data (done: in state variables)
    // step 2: validate data
    let errorList = [];
    let res = "";

    // 2.1: controlli anagrafica:

    res = checkTextValue(formMail, "Email", "mail");
    if (res !== "") errorList.push({ id: "Email", msg: res });
    res = checkTextValue(formNome, "Nome");
    if (res !== "") errorList.push({ id: "Nome", msg: res });
    res = checkTextValue(formCognome, "Cognome");
    if (res !== "") errorList.push({ id: "Cognome", msg: res });
    res = checkTextValue(formTelefono, "Telefono", "phone");
    if (res !== "") errorList.push({ id: "Telefono", msg: res });
    res = checkTextValue(formCap, "CAP", "cap");
    if (res !== "") errorList.push({ id: "Cap", msg: res });
    res = "";
    if (formPassword !== confirmPassword) {
      res = "Le password non corrispondono.";
    } else {
      if (
        !validator.isStrongPassword(formPassword, {
          minLength: 8,
          minLowercase: 1,
          minUppercase: 1,
          minNumbers: 1,
          minSymbols: 0,
        })
      ) {
        res =
          "La password inserita è troppo debole (inserire almeno una maiuscola, una minuscola, un numero. Lunghezza minima 8 caratteri).";
      }
    }
    if (res !== "") {
      errorList.push({ id: "Password", msg: res });
      errorList.push({ id: "Conferma_password", msg: res });
    }
    res = "E' necessario accettare la privacy policy per proseguire.";
    if (!privacyOption) errorList.push({ id: "CkPrivacy", msg: res });

    return errorList;
  }

  function registrationRequest() {
    let errorList = validateForm();

    setErrorList(errorList);
    //console.log(errorList);

    if (errorList.length > 0) {
      setHasMessage(
        "La compilazione è incompleta. Segui le indicazioni e riprova!"
      );
      return;
    }

    let params = [
      { name: "id_sessione", value: props.sessionKey },
      { name: "mail", value: formMail },
      { name: "password", value: formPassword },
      { name: "nome", value: formNome },
      { name: "cognome", value: formCognome },
      { name: "cellulare", value: formTelefono },
      { name: "cap", value: formCap },
    ];
    props.wsCall(
      "https://ws.mediatoys.it/cliente/add_cliente",
      isLoading,
      setIsLoading,
      netError,
      (errMsg) => {
        console.log(errMsg);
        setNetError(errMsg);
      },
      params,
      (respData) => {
        setRispostaWS(respData.message);
        setShowDialog(true);
      }
    );
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="contenitore_registrazione">
      {showDialog ? (
        <OkPopup
          titletext="Esito registrazione"
          text={rispostaWS}
          closeHandler={closeAddedDialog}
        />
      ) : null}
      <h1>Registrati a Bburago!</h1>

      {HasMessage !== null ? messageDialog(HasMessage) : null}
      <CartInputField
        required={true}
        type="email"
        lbl="Email"
        name="Email"
        value={formMail}
        change={setFormMail}
        cssClass="riga_info_cart"
        errList={errorList}
      />

      <CartInputField
        required={true}
        type="text"
        lbl="Nome"
        name="Nome"
        value={formNome}
        change={setFormNome}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="text"
        lbl="Cognome"
        name="Cognome"
        value={formCognome}
        change={setFormCognome}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="cap"
        lbl="CAP"
        name="Cap"
        value={formCap}
        change={setFormCap}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="phone"
        lbl="Telefono"
        name="Telefono"
        value={formTelefono}
        change={setFormTelefono}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="password"
        lbl="Password"
        name="Password"
        value={formPassword}
        change={setFormPassword}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="password"
        lbl="Conferma password"
        name="Conferma_password"
        value={confirmPassword}
        change={setConfirmPassword}
        cssClass="riga_info_cart"
        errList={errorList}
      />
      <CartInputField
        required={true}
        type="checkbox"
        lbl="Ho preso visione e accetto l'informativa sulla Privacy"
        name="CkPrivacy"
        value={privacyOption}
        change={setPrivacyOption}
        cssClass="privacy_cart"
        labelRight={true}
        url={props.cfg.iubendaPrivacyUrl}
        urlText="leggi"
        errList={errorList}
      />
      <input
          className="registrati-registrazione"
          type="button"
          value="Registrati"
          onClick={registrationRequest}
      />
      <p className="test_legenda_form">Nota: la password deve essere di almeno otto caratteri alfanumerici, con almeno una lettera minuscola, una lettera maiuscola e una cifra numerica.</p>
      <div className="clear"></div>
    </div>
    
  );
}

export default Register;
